import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  QueuePageWrapper,
  QueueHeader,
  QueueTitle,
  ViewContainer,
  ViewLayer,
} from "./FeeNoticeQueueStyled";
import ListView from "./components/ListView";
import ReviewView from "./components/ReviewView";
import TeamActivityView from "./components/TeamActivityView";
import { clearCurrentFeeNotice, setFeeNoticeView } from "../../slice/FeeNoticeSlice";

/**
 * Page shell for the SOC / Fee Allocation Notice review queue. Two-view
 * shell (list -> review), not MailIntake's tab bar, because the workflow
 * here is strictly linear per letter (claim from the list, review, go
 * back) rather than several independently-browsable queues.
 */
const FeeNoticeQueue = () => {
  const dispatch = useDispatch();
  const { view, currentItem } = useSelector((state) => state.feeNotices);

  // A hard refresh (or deep link) can land here with view="review" but no
  // claimed item in memory — fall back to the list rather than rendering
  // a dead review pane.
  useEffect(() => {
    if (view === "review" && !currentItem) {
      dispatch(setFeeNoticeView("list"));
      dispatch(clearCurrentFeeNotice());
    }
  }, [dispatch, view, currentItem]);

  return (
    <QueuePageWrapper>
      <QueueHeader>
        <QueueTitle>Fee Notices</QueueTitle>
      </QueueHeader>
      <ViewContainer>
        {view === "activity" ? (
          <TeamActivityView />
        ) : (
          // List and review are CSS-toggled, not swapped (2026-08-20,
          // Matthew: docs must load "lickety split" like the matter
          // viewer). The review pane — and the document engine inside
          // it — stays mounted from the first opened letter until the
          // page unloads, so only the first letter of a session pays
          // the engine boot; every later letter just loads its PDF.
          <>
            <ViewLayer $active={!(view === "review" && currentItem)}>
              <ListView />
            </ViewLayer>
            {currentItem ? (
              <ViewLayer $active={view === "review"}>
                <ReviewView />
              </ViewLayer>
            ) : null}
          </>
        )}
      </ViewContainer>
    </QueuePageWrapper>
  );
};

export default FeeNoticeQueue;
